
<template>
    
        <mars-view class="tab-menu-box"><mars-view class="tab-menu-container"><mars-view v-for="(item,index) in tabMenu" :key="index" :class="['tab-item', curType === item.type ? 'tab-active' : '']" @click.native.stop="tabClick(item)">
            {{ item.name }}
        </mars-view></mars-view><mars-view class="search" @click.native="toSearch"><mars-view class="icon"></mars-view>搜索
    </mars-view></mars-view>
    
</template>

<script>
import log from '../../../static/utils/ubcLog';
import { act } from '../../../static/utils/navigate';
export default {
  data() {
    return {
      // 菜单
      tabMenu: [{
        name: '法律法规',
        type: 0
      }, {
        name: '法律问答',
        type: 1
      }],
      // 当前菜单
      curType: 0
    };
  },
  methods: {
    /**
     * 菜单点击
     */
    tabClick(item) {
      let {
        type
      } = item;
      if (type === this.curType) {
        return;
      }
      log.send && log.send({
        serverId: 17017,
        area: type === 0 ? 'flfg_tab_click' : 'flwd_tab_click',
        action: 'click'
      });
      this.curType = type;
      this.$emit('tabClick', item);
    },
    /**
     * 前往搜索页面
     */
    toSearch() {
      act({
        target: `/pages/qasearch/index?type=${this.curType}`,
        type: 'url'
      });
    }
  }
};
</script>

<style scoped>
.tab-menu-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4.99vw 4.11vw 0;
  border-bottom: 0.16vw solid #edeef0;
}
.tab-menu-box .tab-menu-container {
  display: flex;
  align-items: center;
}
.tab-menu-box .tab-menu-container .tab-item {
  position: relative;
  font-family: PingFang SC;
  font-size: 4.11vw;
  color: #50525c;
  text-align: center;
  line-height: 4.11vw;
  font-weight: 700;
  padding-bottom: 3.22vw;
}
.tab-menu-box .tab-menu-container .tab-item:not(:first-child) {
  margin-left: 9.66vw;
}
.tab-menu-box .tab-menu-container .tab-item.tab-active {
  color: #1e1f24;
}
.tab-menu-box .tab-menu-container .tab-item.tab-active::after {
  content: '';
  position: absolute;
  width: 7.81vw;
  height: 0.97vw;
  background: #4e6ef2;
  border-radius: 0.48vw;
  bottom: -0.16vw;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
}
.tab-menu-box .search {
  display: flex;
  align-items: center;
  font-family: PingFang SC;
  font-size: 4.11vw;
  color: #50525c;
  line-height: 4.11vw;
  padding-bottom: 3.22vw;
}
.tab-menu-box .search .icon {
  margin-right: 0.97vw;
  width: 4.59vw;
  height: 4.59vw;
  background-size: 100% 100%;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/law-regulation/page-search-icon.png');
}

</style>
